// extracted by mini-css-extract-plugin
export default {"textContainer":"References_textContainer__v3k9K"};